module.exports = "/images/vendor/desiigner-svg/svg/ui/avatar.svg?2a60797b0f4cd9e91cf5e1178d7bc1b4";